import Constants from '../actions/types';
import { getRuleTitle } from '../utils';

const initialState = {
  matchingConfig: { rules: [] },
  loading: false,
  message: null,
  severity: null
};

const transformMatchingConfig = payload => {
  const matchingConfig = {
    ...payload,
    rules: payload.rules.map((rule, index) => {
      return {
        id: index + 1,
        name: getRuleTitle(index + 1, rule),
        fields: rule.fields.map((field, idx) => {
          return {
            index: idx + 1,
            fieldName: field.fieldName,
            comparatorFunction: field.comparatorFunction.functionName,
            matchThreshold: field.matchThreshold
          };
        })
      };
    })
  };
  return matchingConfig;
};

const deterMatchingReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.DETERMATCHCONFIG_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.DETERMATCHCONFIG_GET_SUCCESS: {
      const matchingConfig = transformMatchingConfig(action.payload);
      const newState = {
        ...state,
        matchingConfig,
        loading: false
      };

      return newState;
    }

    case Constants.DETERMATCHCONFIG_SAVE_SUCCESS: {
      const newState = {
        ...state,
        message: 'Saved the matching configuration successfully.',
        severity: 'info',
        loading: false
      };

      return newState;
    }

    case Constants.DETERMATCHCONFIG_SAVE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.DETERMODEL_INIT_SUCCESS: {
      const newState = {
        ...state,
        message: 'Started the model initialization operation successfully.',
        severity: 'info',
        loading: false
      };

      return newState;
    }

    case Constants.DETERMODEL_INIT_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.DETERMATCHCONFIG_GET_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.DETERMATCHCONFIG_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default deterMatchingReducer;
